<template>
  <v-container app :fluid="true">
    <v-row>
      <v-col cols="12" class="pt-0 pl-0 pr-0">
        <v-card dark class="summary-cash mr-4" color="#1D5799">
          <v-card-title class="pt-1">
            <span>Total</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <div class="summary-section">
              <span><v-icon>fas fa-coins</v-icon></span>
              <span class="ml-3 cash-amount">{{
                totalCash | currency("S/")
              }}</span>
            </div>
          </v-card-text>
        </v-card>

        <v-card dark class="summary-cash mr-4" color="#4088C7">
          <v-card-title class="pt-1">
            <span>Ventas</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <div class="summary-section">
              <span><v-icon>fas fa-coins</v-icon></span>
              <span class="ml-3 cash-amount">{{
                (totalSalesCash +
                  totalSalesCards +
                  totalPlins +
                  totalTrans +
                  totalYapes)
                  | currency("S/")
              }}</span>
            </div>
          </v-card-text>
        </v-card>

        <v-card dark class="summary-cash mr-4" color="#34B362">
          <v-card-title class="pt-1">
            <span>Cobro de deudas</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <div class="summary-section">
              <span><v-icon>fas fa-coins</v-icon></span>
              <span class="ml-3 cash-amount">{{
                totalPayments | currency("S/")
              }}</span>
            </div>
          </v-card-text>
        </v-card>

        <v-card dark class="summary-cash mr-3" color="#FABC55">
          <v-card-title class="pt-1">
            <span>Ingresos</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <div class="summary-section">
              <span><v-icon>fas fa-coins</v-icon></span>
              <span class="ml-3 cash-amount">{{
                totalIncomes | currency("S/")
              }}</span>
            </div>
          </v-card-text>
        </v-card>

        <v-card dark class="summary-cash" color="#F96654">
          <v-card-title class="pt-1">
            <span>Egresos</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <div class="summary-section">
              <span><v-icon>fas fa-coins</v-icon></span>
              <span class="ml-3 cash-amount">{{
                totalExpenses | currency("S/")
              }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "Summary",
  data() {
    return {
      total: 100,
      total_sales: 100,
      total_payment_customers: 100,
      total_income: 100,
      total_expenses: 100,
    };
  },
  computed: {
    ...mapState("cash", [
      "cashData",
      "incomes",
      "expenses",
      "payments",
      "salesCash",
      "salesCards",
      "totalIncomes",
      "totalExpenses",
      "totalPayments",
      "totalSalesCash",
      "totalSalesCards",
      "totalSales",
      "totalCash",
      "totalPlins",
      "totalTrans",
      "totalYapes",
    ]),
  },
};
</script>

<style>
.summary-cash {
  display: inline-block !important;
  width: 19%;
}

.summary-section {
  text-align: right;
}

.cash-amount {
  font-weight: 500;
  font-size: 19px;
  color: white;
}
</style>
